import { createContext, useContext, type ReactNode } from 'react';

const EvidenceContext = createContext<{
  openEvidence: (title: string, body: string) => void;
}>({
  openEvidence: () => undefined,
});

export function EvidenceProvider({
  children,
  onOpen,
}: {
  children: ReactNode;
  onOpen: (title: string, body: string) => void;
}) {
  return <EvidenceContext.Provider value={{ openEvidence: onOpen }}>{children}</EvidenceContext.Provider>;
}

export function useEvidence() {
  return useContext(EvidenceContext);
}
